// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel_panel__2GA_B","hover-typeB-r":"panel_hover-typeB-r__2uW1v"};